<template>
  <div>
    <h1 class="text-center">
      {{ schema.$title }}
    </h1>

    <fields-required />

    <panel :title="schema.data.tenderer.$title" :is-pesel-field="false" :is-phone-number-field="false">
      <employer :model="schema.data.tenderer" />
    </panel>

    <panel :title="schema.data.employee.$title">
      <employee :model="schema.data.employee" :type-of-profesion="typeOfProfesion" />
    </panel>

    <panel title="III. Oświadczenia">
      <div class="row form-group">
        <div class="col-12">
          <span v-html="replacePlaceholders(schema.data.personalDataStatement.$title)" />
        </div>
      </div>

      <div class="row form-group">
        <div class="col-12">
          <span v-html="replacePlaceholders(schema.data.criminalResponsibility.$title)" />
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import FieldsRequired from '@/components/formComponents/FieldsRequired.vue';
import Panel from '@/components/panel/Panel.vue';
import { ow004Mixin } from '@/mixins/document/ow004';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';

import Employee from '../Employee.vue';
import Employer from '../Employer.vue';

// @vuese
// Formularz wzoru zawiadomienia do OW-004
export default {
  components: {
    Employee,
    Employer,
    FieldsRequired,
    Panel,
    ...components
  },
  mixins: [ow004Mixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  }
};
</script>
